import { NavigateFunction } from "react-router";

export enum PARAM_KEY {
  WAREHOUSE = "entrepot",
  NAVIGATION = "navigation",
  SHORTCUT = "plan.localisation",
  NOTIFICATIONS = "plan.zonenotification",
  FULLSCREEN = "affichage",
  LEGEND = "plan.legende",
}

export enum NOTIFICATIONS_ZONE {
  UNANCHORED = "flottante",
  ANCHORED = "ancree",
}

export enum VIEW_MODE {
  NORMAL = "normal",
  FULLSCREEN = "pleinecran",
}

export enum LEGEND_MODE {
  REDUCED = "reduite",
  FULL = "developpee",
  NONE = "aucune",
}

export const navigation: { navigate: NavigateFunction | null } = {
  navigate: null,
};
